import MetisMenu from 'react-metismenu';


export class CategoryListing extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

            list: []
        };
    }


    render() {
        return <div class="product-categories">
            <h4 className="heading">Product Categories</h4>
            <MetisMenu content={this.props.initialState.data} classNameStateIcon="icon-dropdown-arrow" iconNamePrefix="icon " />
        </div>;
    }
}